module.exports = __webpack_public_path__ + "assets/img/A1.ffb92b17.jpg";